import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaArrowRight, FaCheckCircle, FaCalendarAlt, FaCompass } from "react-icons/fa";
import "./Banner.css";

const Banner = () => {
  const navigate = useNavigate();

  return (
    <section className="cta5" aria-labelledby="cta5-heading">
      <div className="cta5-wrap">
        <motion.div
          className="cta5-container"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {/* Ambient Glow */}
          <div className="cta5-glow" />

          <div className="cta5-main">
            <div className="cta5-copy">
              <span className="cta5-kicker">Free Strategic Consultation</span>

              <h2 id="cta5-heading" className="cta5-title">
                Get a Comprehensive Growth Plan for Your{" "}
                <span className="text-gradient">Website, SEO &amp; Paid Pipeline</span>
              </h2>

              <p className="cta5-sub">
                We review your digital infrastructure, identify your highest-impact
                conversion leaks, and construct an actionable 14-day roadmap with
                concrete ROI forecasts.
              </p>

              <div className="cta5-actions">
                <button
                  className="cta5-btn cta5-btnPrimary"
                  type="button"
                  onClick={() => navigate("/contact")}
                >
                  <FaCalendarAlt />
                  <span>Book Free Strategy Call</span>
                  <FaArrowRight className="btn-arrow" />
                </button>

                <button
                  className="cta5-btn cta5-btnOutline"
                  type="button"
                  onClick={() => navigate("/services")}
                >
                  <FaCompass />
                  <span>Explore Capabilities</span>
                </button>
              </div>
            </div>

            <aside className="cta5-side" aria-label="What is included">
              <div className="cta5-side-head">
                <p className="cta5-sideLabel">What You Get in 30 Mins</p>
                <p className="cta5-sideSub">
                  No generic slides. A bespoke technical and commercial audit for your brand.
                </p>
              </div>

              <div className="cta5-list">
                <div className="cta5-li">
                  <FaCheckCircle className="cta-check" />
                  <div>
                    <div className="cta5-liTitle">Top 3 Conversion Blockers</div>
                    <div className="cta5-liText">
                      Immediate UX &amp; messaging fixes to raise leads right away.
                    </div>
                  </div>
                </div>

                <div className="cta5-li">
                  <FaCheckCircle className="cta-check" />
                  <div>
                    <div className="cta5-liTitle">Competitor Search Gap Audit</div>
                    <div className="cta5-liText">
                      Exact organic and paid keywords your competitors dominate.
                    </div>
                  </div>
                </div>

                <div className="cta5-li">
                  <FaCheckCircle className="cta-check" />
                  <div>
                    <div className="cta5-liTitle">Tracking &amp; Attribution Plan</div>
                    <div className="cta5-liText">
                      Clean event-tracking setup so you know your true cost per lead.
                    </div>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Banner;
